import styled from "styled-components";
import { HTMLMotionProps, motion } from "framer-motion";
import React from "react";
import { LeftCarousel } from "public/static/icons";
import { Typography } from "@shared/ui/Typography";
import { ThemeColorsType } from "@providers/ThemeProvider/theme";

interface IProps extends HTMLMotionProps<"button"> {
  onClick: () => void;
  label: string;
  className?: string;
  color?: ThemeColorsType;
}

export function PageBackButton({ onClick, color, label, className }: IProps) {
  return (
    <StyledView
      className={className}
      onClick={onClick}
      $color={color}
      type="button"
    >
      <LeftCarousel />
      <Typography color={color}>{label}</Typography>
    </StyledView>
  );
}

const StyledView = styled(motion.button)<{ $color: IProps["color"] }>`
  display: grid;
  grid-gap: 0.8rem;
  grid-auto-flow: column;
  justify-content: flex-start;
  align-items: center;

  svg {
    width: 2.4rem;
    height: 2.4rem;
    path {
      fill: ${(props) =>
        props.$color
          ? props.theme.colors[props.$color]
          : props.theme.colors.basic_black};
    }
  }
`;
